import {useEffect, useRef} from "react";
import SystemLeaveFlashDialog from "../../../components/dialogs/SystemLeaveFlashDialog";
import {isArrayNullUndefinedOrEmpty} from "../../../services/Validator";
import SystemExistingFlashSnackBar from "../../../components/snackbars/SystemExistingFlashSnackBar";
import {PageView} from "../../../enums/PageView";
import {recordPageViewMetric} from "../../../services/AnalyticsRecorder";
import FlashResultsTopBar from "../../../components/bars/courses/flash/FlashResultsTopBar";
import FlashResultsDesktopScoreCard from "../../../components/cards/courses/flash/FlashResultsDesktopScoreCard";
import FlashResultsDesktopGraphCard from "../../../components/cards/courses/flash/FlashResultsDesktopGraphCard";
import FlashResultsDesktopQuestionsCard from "../../../components/cards/courses/flash/FlashResultsDesktopQuestionsCard";
import FlashResultsTabletQuestionsCard from "../../../components/cards/courses/flash/FlashResultsTabletQuestionsCard";
import FlashResultsTabletSummary from "../../../components/others/courses/flash/FlashResultsTabletSummary";
import FlashResultsTabletContentLayout from "../../../components/layouts/courses/flash/FlashResultsTabletContentLayout";
import FlashResultsDesktopContentLayout
    from "../../../components/layouts/courses/flash/FlashResultsDesktopContentLayout";
import FlashResultsDesktopSummaryLayout
    from "../../../components/layouts/courses/flash/FlashResultsDesktopSummaryLayout";

export default function FlashResultsScreen({selectedGrade,
                            questions,
                            isLeaveModalOpen,
                            setIsLeaveModalOpen,
                            onLeaveFlashPressed,
                            leaveFlash,
                            isSnackbarOpen,
                            handleClose}) {
    // Used in MetaCoursesScreen component to display flash results made of global
    // score, graphical representation, and questions list with access to single
    // correction screen

    // PROPERTIES
    // ---- PageViewMetric
    const hasTrackedView = useRef(false);

    // HOOKS
    // ---- At rendering : if local flash is in storage, set flash variables
    useEffect(() => {
        if (!hasTrackedView.current) {
            // Avoid double trigger in dev, due to React Strict mode
            recordPageViewMetric(PageView.RESULTS);
            hasTrackedView.current = true;
        }
    }, []);

    // BUILD
    if (isArrayNullUndefinedOrEmpty(questions))
        return null;
    return(
        <div className="overflow-auto animate-appear w-full h-[100svh] bg-backgroundLight3 flex flex-col justify-start items-center">
            {/** SNACKBAR */}
            <SystemExistingFlashSnackBar open={isSnackbarOpen}
                                         handleClose={handleClose} />
            {/** MODAL */}
            <SystemLeaveFlashDialog open={isLeaveModalOpen}
                                    handleClose={() => setIsLeaveModalOpen(false)}
                                    leave={leaveFlash} />
            {/** TOP BARS */}
            <FlashResultsTopBar selectedGrade={selectedGrade}
                                onLeaveFlashPressed={onLeaveFlashPressed} />
            {/** CONTENT */}
            <div className={"overflow-auto bg-backgroundLight3 w-full grow flex flex-col items-center"}>
                {/** ---- TABLET */}
                <FlashResultsTabletContentLayout>
                    <FlashResultsTabletSummary scores={computeFlashScores()[0]}
                                               total={questions?.length} />
                    <FlashResultsTabletQuestionsCard questions={questions} />
                </FlashResultsTabletContentLayout>
                {/** ---- DESKTOP */}
                <FlashResultsDesktopContentLayout>
                    <FlashResultsDesktopSummaryLayout>
                        <FlashResultsDesktopScoreCard scores={computeFlashScores()[0]}
                                                      total={questions?.length} />
                        <FlashResultsDesktopGraphCard scores={computeFlashScores()[0]}/>
                    </FlashResultsDesktopSummaryLayout>
                    <FlashResultsDesktopQuestionsCard questions={questions}
                                                      selectedGrade={selectedGrade} />
                </FlashResultsDesktopContentLayout>
            </div>
        </div>
    );

    // METHODS
    // ---- Compute flash scores
    function computeFlashScores() {
        // Prepare
        let scores = [0, 0, 0]
        // Compute
        for (let i = 0; i < questions?.length; i++) {
            // Scores
            if (questions[i].selectedOption.isCorrect === null) {
                scores[2] += 1
            } else {
                questions[i].selectedOption.isCorrect ? scores[0] += 1 : scores[1] += 1
            }
        }
        // Return
        return [scores]
    }
}